import { Button, Col, Menu, Modal, Row, Select, Table, Typography } from 'antd';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import DropdownAction from '@root/modules/Warehouse/Shared/Actions/DropdownAction';
import { useEffect, useRef, useState } from 'react';
import SearchBox from '../components/SearchBox';
import {
  CloseOutlined,
  HomeOutlined,
  MailOutlined,
  PaperClipOutlined,
  SendOutlined
} from '@ant-design/icons';
import { Editor } from '@toast-ui/react-editor';
import forwardingService from '../services/forwarding';
import DetailsPro from '@root/modules/Forwarder/Detail/components/DetailsPro';
import ShipmentMethodCanEdit from '@root/modules/Warehouse/Inquiry/components/shipping/ShipmentMethodCanEdit';
import ShippingPlant from '@root/modules/Warehouse/Inquiry/components/shipping/ShippingPlant';
import CheckPoint from '@root/modules/Warehouse/Shared/Common/CheckPoint';
const SellerForwarding = () => {
  const editorRef = useRef<Editor>(null);
  const [fileList, setFileList] = useState<any[]>([]);
  const [isSelectModalOpen, setIsSelectModalOpen] = useState(false);
  const [forwardingList, setForwardingList] = useState<any[]>([]);
  const [selectedQuotation, setSelectedQuotation] = useState<any>();
  const [progress, setProgress] = useState(0);
  const [mode, setMode] = useState('');
  const handleUploadChange = (e: any) => {
    if (e.target.files[0]) {
      setFileList([...fileList, e.target.files[0]]);
    }
  };
  const [descriptionModal, setDescriptionModal] = useState(false);
  const [description, setDescription] = useState('');

  const [quotationList, setQuotationList] = useState<any[]>([]);

  const fetchQuotationList = async () => {
    const res = await forwardingService.getQuotationList();
    console.log(res, 'res');
    setQuotationList(res.data);
  };

  const handleFileDelete = (fileName: string) => {
    setFileList(
      fileList.filter((file) => {
        if ('name' in file && !('uploadFile' in file)) {
          return file.name !== fileName;
        }
        return file.uploadFile.fileName !== fileName;
      })
    );
  };
  const [search, setSearch] = useState('');
  const [selectValue, setSelectValue] = useState('country');
  const [selectedRecord, setSelectedRecord] = useState<any>();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const fetchForwardingList = async () => {
    const res = await forwardingService.getForwardingList(
      page,
      selectValue,
      search
    );
    setForwardingList(res.data);
    setTotal(res.count);
  };
  console.log(forwardingList);

  useEffect(() => {
    fetchQuotationList();
  }, []);
  useEffect(() => {
    fetchForwardingList();
  }, [selectValue, search, page]);
  const onUploadImage = async (blob: File, callback: any) => {
    const url = await forwardingService.uploadFile([blob]);
    callback(url.data.attachments[0].url, '');
    return false;
  };

  const [content, setContent] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const breadcrumbList = [
    { url: '', tittle: '포워딩 업체 문의' },
    { url: '', tittle: '포워딩 업체 조회' }
  ];
  const columns = [
    {
      title: 'No',
      dataIndex: 'id',
      key: 'id',
      width: 50
    },
    {
      title: '업체명',
      dataIndex: 'name',
      key: 'name',
      width: 180
    },
    {
      title: '국가',
      dataIndex: 'country',
      key: 'country',
      width: 70
    },
    {
      title: <div style={{ whiteSpace: 'nowrap', width: 85 }}>소통 언어</div>,
      dataIndex: 'locale',
      key: 'locale'
    },
    {
      title: '주요 업무',
      dataIndex: 'description',
      key: 'description',
      width: 900,
      render: (text: string) => {
        return (
          <div
            onClick={() => {
              setDescription(text);
              setDescriptionModal(true);
            }}
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {text}
          </div>
        );
      }
    },

    {
      title: '',
      dataIndex: 'icon',
      key: 'icon',
      width: 55,
      render: (_: any, record: any) => (
        <div
          onClick={() => {
            console.log(record);
            setSelectedRecord(record);
            setIsSelectModalOpen(true);
          }}
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <div
            style={{
              width: 24,
              height: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 99999,
              backgroundColor: '#F8F9FE'
            }}
          >
            <MailOutlined className="custom-svg12" />
          </div>
        </div>
      )
    }
  ];

  console.log(selectedRecord);
  console.log(quotationList);

  const menu = [
    {
      id: 2,
      titleSelect: '선택',
      list: (
        <Menu
          onClick={(e) => setSelectValue(e.key)}
          items={[
            { label: '업체명', key: 'name' },
            { label: '국가', key: 'country' }
          ]}
        />
      )
    }
  ];

  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="busk-container">
        <div style={{ display: 'flex', gap: 2 }}>
          {menu.map((item) => {
            return (
              <DropdownAction
                key={item.id}
                titleSelect={selectValue === 'name' ? '업체명' : '국가'}
                list={item.list}
              />
            );
          })}

          <SearchBox onChange={setSearch} />
        </div>
        <div style={{ marginTop: 20, backgroundColor: 'white' }}>
          <div className="busk-sellerSubHead">
            <Row align="middle">
              <Col flex="auto">
                <Row gutter={15}>
                  <Col>
                    <Typography.Text>
                      총 포워딩 업체 {total ? total : '00'}
                    </Typography.Text>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <Table
            // scroll={{ x: 'max-content' }}
            className="busk-table"
            pagination={{
              pageSize: 10,
              total: total,
              onChange: (newPage) => {
                setPage(newPage);
              }
            }}
            // loading={loading}
            columns={columns}
            dataSource={forwardingList}
          />
          <Modal
            width={'auto'}
            closeIcon={<CloseOutlined />}
            onCancel={() => setIsSelectModalOpen(false)}
            title="문의 방식"
            centered
            footer={null}
            className="forwarding-modal"
            visible={isSelectModalOpen}
          >
            <div style={{ display: 'flex', gap: 16 }}>
              <div
                onClick={() => {
                  if (quotationList.length === 0) {
                    return;
                  }
                  setMode('quotation');
                  setIsSelectModalOpen(false);
                  setIsModalOpen(true);
                }}
                style={{
                  backgroundColor: quotationList.length
                    ? '#2B2C51'
                    : 'rgba(43, 44, 81, 0.5)',
                  padding: '32px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                  alignItems: 'center',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  width: 200
                }}
              >
                <HomeOutlined className="icon-24" style={{ color: '#fff' }} />
                <p
                  style={{
                    fontSize: '18px',
                    fontWeight: 500,
                    color: '#fff',
                    marginBottom: 0
                  }}
                >
                  창고 견적 연동하기
                </p>
              </div>
              <div
                onClick={() => {
                  setIsSelectModalOpen(false);
                  setMode('default');
                  setProgress(1);
                  setIsModalOpen(true);
                }}
                style={{
                  backgroundColor: '#2B2C51',
                  padding: '32px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                  alignItems: 'center',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  width: 200
                }}
              >
                <SendOutlined className="icon-24" style={{ color: '#fff' }} />
                <p
                  style={{
                    fontSize: '18px',
                    fontWeight: 500,
                    color: '#fff',
                    marginBottom: 0
                  }}
                >
                  일반 문의
                </p>
              </div>
            </div>
            {quotationList.length === 0 && (
              <p
                style={{
                  marginTop: 12,
                  textAlign: 'left',
                  width: '100%',
                  fontSize: 14,
                  marginBottom: 0
                }}
              >
                *등록된 견적서가 없어, 창고 견적 연동하기는 불가능합니다.
                <br />
                견적서 등록 후 이용해주시겨나. 일반 문의를 이용해주세요.
              </p>
            )}
          </Modal>
          <Modal
            style={{ borderRadius: 8, overflow: 'hidden' }}
            width={'auto'}
            closeIcon={<CloseOutlined />}
            onCancel={() => {
              setIsModalOpen(false);
              setContent('');
              setFileList([]);
              setProgress(0);
              setSelectedQuotation(null);
            }}
            title="메세지 작성"
            className="forwarding-modal"
            visible={isModalOpen}
            footer={[
              <button
                onClick={async () => {
                  if (progress === 1) {
                    let filesId = [];

                    // 새로 업로드된 파일이 있는 경우에만 파일 업로드 API 호출
                    const newFiles = fileList.filter(
                      (file) => 'name' in file && !('uploadFile' in file)
                    ) as File[];
                    if (newFiles.length > 0) {
                      const files = await forwardingService.uploadFile(
                        newFiles
                      );
                      filesId = files?.data?.attachments?.map(
                        (file: any) => file.id
                      );
                    }

                    // 기존 파일들의 ID 추가
                    const existingFileIds = fileList
                      .filter((file) => 'uploadFile' in file)
                      .map((file) => file.uploadFile.id);

                    filesId = [...filesId, ...existingFileIds];

                    await forwardingService.createForwardingMessage({
                      forwardId: selectedRecord.id,
                      content: content,
                      attachment: filesId,
                      quotationId: selectedQuotation
                    });
                    alert('메세지 전송 완료');
                    setContent('');
                    setFileList([]);
                    setProgress(0);
                    setSelectedQuotation(null);
                    setIsModalOpen(false);
                  } else {
                    setProgress(1);
                  }
                }}
                disabled={progress === 1 ? !!!content : !selectedQuotation}
                className="forwarding-btn"
              >
                {progress === 0 ? '다음' : '메세지 전송'}
              </button>
            ]}
            centered
          >
            {mode === 'quotation' && (
              <div>
                <p>견적서 No</p>
                <Select
                  disabled={progress === 1}
                  style={{ width: 240, marginBottom: 12 }}
                  onChange={(value) => setSelectedQuotation(value)}
                >
                  {quotationList?.map((item) => (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  ))}
                </Select>
              </div>
            )}
            {progress === 0 ? (
              <>
                <DetailsPro
                  {...quotationList?.find(
                    (item) => item.id === selectedQuotation
                  )?.products?.[0]}
                />
                <div
                  style={{
                    display: 'flex',
                    marginTop: '15px',
                    gap: '10px'
                  }}
                >
                  <ShipmentMethodCanEdit
                    shipmentMethod={
                      quotationList?.find(
                        (item) => item.id === selectedQuotation
                      )?.shipmentMethod
                    }
                  />
                  <ShippingPlant
                    shippingPlanEta={
                      quotationList?.find(
                        (item) => item.id === selectedQuotation
                      )?.shippingPlanEta
                    }
                    shippingPlanEtd={
                      quotationList?.find(
                        (item) => item.id === selectedQuotation
                      )?.shippingPlanEtd
                    }
                  />
                  <CheckPoint
                    data={{
                      checkPoint: quotationList?.find(
                        (item) => item.id === selectedQuotation
                      )?.comment
                    }}
                  />
                </div>
              </>
            ) : (
              <>
                <Editor
                  initialEditType="wysiwyg"
                  hooks={{
                    addImageBlobHook: (blob, callback) =>
                      onUploadImage(blob as File, callback)
                  }}
                  ref={editorRef}
                  onChange={() =>
                    setContent(
                      editorRef.current?.getInstance().getMarkdown() || ''
                    )
                  }
                  hideModeSwitch={true}
                />
                <div className="file-wrap">
                  <label htmlFor="file" className="file-btn">
                    <span>파일</span>
                    <PaperClipOutlined width={16} height={16} />
                  </label>
                  <input
                    onChange={handleUploadChange}
                    type="file"
                    id="file"
                    style={{ display: 'none' }}
                  />
                  <div style={{ display: 'flex', gap: 12, overflowX: 'auto' }}>
                    {fileList.map((file, index) => (
                      <Button className="file-name" key={index}>
                        <span>
                          {'name' in file && !('uploadFile' in file)
                            ? file.name
                            : file.uploadFile.fileName}
                        </span>
                        <CloseOutlined
                          onClick={() =>
                            handleFileDelete(
                              'name' in file && !('uploadFile' in file)
                                ? file.name
                                : file.uploadFile.fileName
                            )
                          }
                        />
                      </Button>
                    ))}
                  </div>
                </div>
              </>
            )}
          </Modal>
          <Modal
            footer={null}
            centered
            className="forwarding-modal description-modal"
            open={descriptionModal}
            onCancel={() => setDescriptionModal(false)}
            title="주요 업무"
          >
            <span style={{ textAlign: 'left', width: '100%' }}>
              {description}
            </span>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default SellerForwarding;
